import { get } from "@/utils/http";
let baseURL = "/dic";

//获取数据字典
const dicList = data => get(`${baseURL}/dicList`, data);

// userAPI
export default {
  dicList
};
